import request from '@/utils/request'

//HTTP GET请求
function get(url, data) {
    let option = {
        url: url,
        method: 'get',
        params: data
    }
    return request(option);
}

//HTTP POST请求
function post(url, data) {
    let option = {
        url: url,
        method: 'post',
        data
    }
    return request(option);
}

function exportData(url, data) {
    let option = {
        url: url,
        method: 'post',
        responseType:'blob',
        data
    }
    return request(option);
}

export default {
    get: get,
    post:post,
    exportData:exportData,
}


// WEBPACK FOOTER //
// ./src/api/requst.js